<script setup lang="ts">
import BaseBanner from './base/BaseBanner.vue'
import { useSpecialCollectibleChallenge } from '@/composables/game/challenges'

withDefaults(defineProps<{
	pulsate?: boolean
}>(), {
  pulsate: false,
})

const { specialCollectibleChallengeName } = useSpecialCollectibleChallenge()

</script>

<template>
  <BaseBanner
    :pulsate="pulsate"
    show-live-chip
  >
    <div class="flex items-center justify-center w-full h-full relative overflow-hidden">
      <img
        class="w-full h-full object-cover"
        src="@/assets/images/challenges/collectible/collectible-challenge-banner.webp"
        alt="Collectible Challenge Banner"
      >
      <h2 class="font-pilat font-black text-[32px] leading-7 text-white text-center absolute max-w-[150px] -mt-1">
        {{ specialCollectibleChallengeName }}
      </h2>
    </div>
  </BaseBanner>
</template>

<style scoped>
.banner-title {
	text-align: center;
	text-shadow: 0 0 19.473px rgba(0, 0, 0, 0.16);
	-webkit-text-stroke-width: 3px;
	-webkit-text-stroke-color: #000;
	font-size: 32px;
	font-style: normal;
	font-weight: 700;
	line-height: 100%;

	filter: drop-shadow(0px 0px 10.433px rgba(0, 0, 0, 0.66));
	background: var(--Lingogold, linear-gradient(269deg, #F5C250 -31.87%, #FFFF9F 65.88%, #FFCD58 97.27%));
	background-clip: text;
	-webkit-background-clip: text;
	-webkit-text-fill-color: transparent;
}
</style>
